import { LOCAL_STORAGE_CLIENT_UUID } from "constants/localStore";
import localforage from "localforage";
import { getLocalStorageOneItem, setLocalStorageOneItem } from "utils/localStorage";

const defaultLocalForage = localforage.createInstance({
  name: "gs_web_app",
  version: 1.0,
});

const clearDefaultLocalForage = async () => {
  const persistedUUID = getLocalStorageOneItem(LOCAL_STORAGE_CLIENT_UUID);

  try {
    await defaultLocalForage.clear();
  } catch {}

  if (persistedUUID) {
    setLocalStorageOneItem(LOCAL_STORAGE_CLIENT_UUID, persistedUUID);
  }
};

export { defaultLocalForage, clearDefaultLocalForage };
